<template lang="pug" src="./html/LondonWorkCampaignAR-Body.pug"></template>

<script>
    import PortfolioItemBase from './PortfolioItemBase'
    import JSARLoader from '../../tools/jsar-loader'
    import Vue from 'vue'
    import EventBus from './../../../event-bus'
    import StageUtils from '../../tools/stage-utils'

    const PATTERN_FILE = '/LondonWorkCampaignAR/marker.pat'
    const OVERLAY_IMAGE = '/LondonWorkCampaignAR/overlay.png'

    function invertContext (ctxIn, ctxOut, x, y, w, h) {
      let imgData = ctxIn.getImageData(x, y, w, h)
      let data = imgData.data

      let i = 0
      while (i < data.length) {
        data[i] = 255 - data[i]
        data[i + 1] = 255 - data[i + 1]
        data[i + 2] = 255 - data[i + 2]
        i += 4
      }

      ctxOut.putImageData(imgData, x, y)
    }

    const MagiReCreationIssue = {
      display: null,
      canvasGL: document.createElement('canvas'),
      webcamOutputReady: false
    }

    class JSAR {
      constructor (elements, width, height, flipHorizontal) {
        this.elements = elements
        this.width = width
        this.height = height
        this.isActive = false
        this.flipHorizontal = flipHorizontal
        this.init()
      }
      init () {
        let vm = this

        this.ctxIn = this.elements.canvasIn.getContext('2d')
        this.ctxOut = this.elements.canvasOut.getContext('2d')
        this.raster = new window.NyARRgbRaster_Canvas2D(this.elements.canvasIn)
        let param = new window.FLARParam(this.width, this.height)

        this.resultMat = new window.NyARTransMatResult()
        if (MagiReCreationIssue.display) {
          this.display = MagiReCreationIssue.display
        } else {
          MagiReCreationIssue.display = this.display = new window.Magi.Scene(MagiReCreationIssue.canvasGL)
          this.display.camera.useProjectionMatrix = true
          MagiReCreationIssue.canvasGL.addEventListener('click', function () {
            EventBus.dispatchEvent('LondonWorkCampaignAR.WEBCAM_PAUSE')
          })
        }

        param.copyCameraMatrix(this.display.camera.perspectiveMatrix, 10, 10000)

        this.videoTex = new window.Magi.FlipFilterQuad()
        this.videoTex.material.textures.Texture0 = new window.Magi.Texture()
        this.videoTex.material.textures.Texture0.image = this.elements.canvasOut
        this.videoTex.material.textures.Texture0.generateMipmaps = false
        this.display.scene.appendChild(this.videoTex)

        this.marker = {}

        if (this.flipHorizontal) {
          this.ctxOut.translate(this.width, 0)
          this.ctxOut.scale(-1, 1)
        }

        Vue.http.get(PATTERN_FILE).then(
          function (e) {
            if (vm.aborted) {
              return null
            }

            let mpattern = new window.FLARCode(64, 64)
            mpattern.loadARPatt(e.body)

            vm.detector = new window.FLARSingleMarkerDetector(param, mpattern, 100)
            vm.detector.setContinueMode(true)

            let img = document.createElement('img')
            img.onload = function () {
              let overlayNode = new window.Magi.Node()
              overlayNode.transform = window.mat4.identity()
              overlayNode.setScale(100)

              let overlayImg = new window.Magi.Image(img)
              overlayImg.setZ(0.001)
              overlayImg.setScale(1 / 98)
              overlayNode.appendChild(overlayImg)

              vm.overlay = overlayNode

              vm.display.scene.appendChild(overlayNode)
            }
            img.src = OVERLAY_IMAGE

            vm.isActive = true
            vm.update()
          },
          function (e) {
            console.log('JSAR init() Error:', e)
          }
        )
      }
      destroy () {
        if (this.overlay) {
          this.display.scene.removeChild(this.overlay)
        }
        this.aborted = true
        this.isActive = false
        MagiReCreationIssue.webcamOutputReady = false
      }
      pause () {
        this.isPaused = true
      }
      resume () {
        if (this.isPaused) {
          this.isPaused = false
          this.update()
        }
      }
      update () {
        if (!this.isActive || this.aborted || this.isPaused) {
          return null
        }

        try {
          this.processVisuals()
          this.processDetection()
          if (this.overlay) this.renderOverlay()
        } catch (e) {
          console.log('JSAR update() Error:', e)
        }

        let vm = this
        window.requestAnimationFrame(function () {
          vm.update()
        })

        if (!MagiReCreationIssue.webcamOutputReady) {
          StageUtils.scrollTo(0, vm.elements.bizcard.offsetTop - 55)
          MagiReCreationIssue.webcamOutputReady = true
          this.elements.canvasPlaceholder.parentNode.replaceChild(MagiReCreationIssue.canvasGL, this.elements.canvasPlaceholder)
        }
      }
      processVisuals () {
        this.ctxOut.drawImage(this.elements.webcam, 0, 0, this.width, this.height)
        invertContext(this.ctxOut, this.ctxIn, 0, 0, this.width, this.height)
        this.elements.canvasIn.changed = true

        this.videoTex.material.textures.Texture0.changed = true
        this.videoTex.material.textures.Texture0.upload()
      }
      processDetection () {
        this.detected = this.detector.detectMarkerLite(this.raster, 170) && this.detector.getConfidence() > 0.4

        if (!this.detected) return null

        this.detector.getTransformMatrix(this.resultMat)
        this.marker.transform = Object.asCopy(this.resultMat)
      }
      renderOverlay () {
        if (!this.detected) {
          if (this.overlay.display) {
            this.overlay.display = false
          }
          return null
        }

        this.overlay.display = true

        let arMat = this.marker.transform
        let glMat = this.overlay.transform

        glMat[0] = arMat.m00
        glMat[1] = -arMat.m10
        glMat[2] = arMat.m20
        glMat[3] = 0
        glMat[4] = arMat.m01
        glMat[5] = -arMat.m11
        glMat[6] = arMat.m21
        glMat[7] = 0
        glMat[8] = -arMat.m02
        glMat[9] = arMat.m12
        glMat[10] = -arMat.m22
        glMat[11] = 0
        glMat[12] = arMat.m03
        glMat[13] = -arMat.m13
        glMat[14] = arMat.m23
        glMat[15] = 1
      }
    }

    export default {
      extends: PortfolioItemBase,
      beforeCreate () {
        this._data = {
          output: 'init',
          webcamMsg: '',
          webcamReady: false,
          webcamIsPaused: false,
          isIOS: /iPhone|iPad/i.test(navigator.userAgent) ? 'ios' : ''
        }
      },
      mounted () {
        this.tryCam()
        EventBus.$on('LondonWorkCampaignAR.WEBCAM_PAUSE', this.webcamPause)
      },
      beforeDestroy () {
        clearTimeout(this.arlockTimout)
        this.webcamStop()
        if (this.jsar) {
          this.jsar.destroy()
        }
        EventBus.$off('LondonWorkCampaignAR.WEBCAM_PAUSE', this.webcamPause)
      },
      methods: {
        onPortfolioNavChange (e) {
          if (Number(this.index) === -e.index) {
          } else {
            this.webcamPause()
          }
        },
        tryCam (obj) {
          obj = obj || this
          if (JSARLoader.loader.status === JSARLoader.statusOptions.AVAILABLE) {
            obj.webcamAvailable()
          } else if (JSARLoader.loader.status === JSARLoader.statusOptions.NOT_AVAILABLE) {
            obj.webcamNotAvailable()
          } else {
            obj.arlockTimout = setTimeout(obj.tryCam, 200, obj)
          }
        },
        webcamNotAvailable () {
          this._data.webcamMsg = 'webcamNotAvailable'
        },
        webcamBlocked (e) {
          // TODO
          this._data.output += ' | webcamBlocked(' + e + ')'
          console.log('webcamBlocked', e)
          this._data.webcamMsg = 'webcamBlocked'
          this._data.webcamReady = false
          this._webcamActivated = false
        },
        webcamAvailable () {
          this._data.webcamMsg = 'webcamAvailable'
          this._webcamAvailable = true
        },
        webcamActivate () {
          if (this._webcamActivated || !this._webcamAvailable) return
          this._webcamActivated = true
          this._data.webcamMsg = 'webcamActivating'
          this.webcamResume()
          let vm = this
          navigator.mediaDevices.getUserMedia({
            audio: false,
            video: {
              facingMode: 'environment'
            }
          }).then(
            function (stream) {
              let flipHorizontal = vm.$store.state.iOS
              let tracks = stream.getTracks()
              tracks.forEach(function (track) {
                vm._data.output += ' | webcamPlaying(' + track.label + ')'
                if (track.label === 'Back Camera') {
                  flipHorizontal = false
                }
              })

              vm._data.webcamReady = true
              vm._data.webcamMsg = ''
              vm.setupAR(stream, flipHorizontal)
            }
          ).catch(
            function (e) {
              vm.webcamBlocked(e)
            }
          )
        },
        webcamResume () {
          this._data.webcamIsPaused = false
          if (this.jsar) {
            this.jsar.resume()
          }
          if (this.stream) {
            let tracks = this.stream.getTracks()
            tracks.forEach(function (track) {
              track.enabled = true
            })
          }
        },
        webcamPause () {
          this._data.webcamIsPaused = true
          if (this.jsar) {
            this.jsar.pause()
          }
          if (this.stream) {
            let tracks = this.stream.getTracks()
            tracks.forEach(function (track) {
              track.enabled = false
            })
          }
        },
        webcamStop () {
          this._data.webcamReady = false
          this._webcamActivated = false
          if (this.stream) {
            let tracks = this.stream.getTracks()
            tracks.forEach(function (track) {
              track.stop()
            })
          }
        },
        setupAR (stream, flipHorizontal) {
          let vm = this
          this.stream = stream
          this.$refs.webcam.addEventListener('loadedmetadata', function (e) {
            let r = this.getBoundingClientRect()

            let canvasIn = document.createElement('canvas')
            let canvasOut = document.createElement('canvas')
            canvasIn.width = canvasOut.width = this.videoWidth
            canvasIn.height = canvasOut.height = this.videoHeight

            MagiReCreationIssue.canvasGL.width = r.width
            MagiReCreationIssue.canvasGL.height = r.height

            vm.jsar = new JSAR({
              webcam: vm.$refs.webcam,
              canvasIn: canvasIn,
              canvasOut: canvasOut,
              canvasPlaceholder: vm.$refs.canvasPlaceholder,
              bizcard: vm.$refs.bizcard
            }, this.videoWidth, this.videoHeight, flipHorizontal)
          }, {
            once: true
          })
          let video = this.$refs.webcam
          if ('srcObject' in video) {
            video.srcObject = stream
          } else {
            video.src = window.URL.createObjectURL(stream)
          }
          setTimeout(() => {
            video.play()
          }, 500)
        }
      },
      data () {
        return this._data
      }
    }
</script>
